export default __webpack_public_path__ + "static/david2-8a14bba9dadf99fdcc6db37ce2eda239.jpg";